import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const articles = [
  {
    slug: "yoybuy-sheet-guide",
    typeKey: "article_1_type",
    titleKey: "article_1_title",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20and%20product%20images%20soft%20natural%20light%20modern%20office%20setup%20editorial%20photography%20with%20warm%20neutral%20tones%20professional%20aesthetic&width=600&height=400&seq=article-guide-img&orientation=landscape",
  },
  {
    slug: "yoybuy-sheet-guide",
    typeKey: "article_2_type",
    titleKey: "article_2_title",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20concept%20with%20clean%20minimalist%20design%20showing%20spreadsheet%20versus%20manual%20paper%20order%20soft%20neutral%20background%20editorial%20style%20modern%20aesthetic&width=600&height=400&seq=article-compare-img&orientation=landscape",
  },
  {
    slug: "yoybuy-sheet-guide",
    typeKey: "article_3_type",
    titleKey: "article_3_title",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimalist%20spreadsheet%20template%20displayed%20on%20laptop%20screen%20with%20soft%20pastel%20colored%20cells%20modern%20office%20environment%20editorial%20photography%20professional%20aesthetic&width=600&height=400&seq=article-template-img&orientation=landscape",
  },
  {
    slug: "yoybuy-sheet-guide",
    typeKey: "article_4_type",
    titleKey: "article_4_title",
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20warehouse%20with%20organized%20product%20boxes%20and%20laptop%20showing%20spreadsheet%20data%20soft%20natural%20lighting%20clean%20professional%20editorial%20style%20warm%20neutral%20tones&width=600&height=400&seq=article-business-img&orientation=landscape",
  },
];

export default function ArticleGallery() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 bg-background-200/50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              {t("articles_title")}{" "}
              <span className="text-accent-500">{t("articles_title_accent")}</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 font-light mt-2">
              {t("articles_subtitle")}
            </p>
          </div>
          <span className="hidden md:inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 rounded-full text-xs font-semibold whitespace-nowrap">
            {t("articles_seo_tag")}
          </span>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-2 px-2 scrollbar-hide">
          {articles.map((article, idx) => (
            <Link
              key={idx}
              to={`/article/${article.slug}`}
              className="flex-shrink-0 w-[260px] md:w-[300px] bg-background-50 rounded-2xl overflow-hidden group cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-full h-[180px] md:h-[200px] bg-background-100 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={t(article.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <p className="text-xs text-foreground-400 font-medium mb-2">
                  {t(article.typeKey)}
                </p>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-3 line-clamp-2">
                  {t(article.titleKey)}
                </h3>
                <span className="inline-flex items-center text-primary-600 font-bold text-xl">
                  &rarr;
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 md:hidden">
          <span className="px-4 py-1.5 bg-secondary-100 text-secondary-800 rounded-full text-xs font-semibold whitespace-nowrap">
            {t("articles_seo_tag")}
          </span>
        </div>
      </div>
    </section>
  );
}